import { WidgetContent } from "./widget-content.model";

export class PageWidget {

  public id: string;
  public pageWidgetID: number;
  public widgetTemplateID: number;
  public dynamicPageID: number;
  public sortOrder: number;
  public index: number;
  public createdBy: number;
  public createdDate: Date;
  public widgetContentList: WidgetContent[];
  public isMobile: boolean;
}



// WEBPACK FOOTER //
// ./src/app/models/widget/page-widget.model.ts